import { render, staticRenderFns } from "./Whitepaper.vue?vue&type=template&id=df8949aa&scoped=true"
import script from "./Whitepaper.vue?vue&type=script&lang=js"
export * from "./Whitepaper.vue?vue&type=script&lang=js"
import style0 from "./Whitepaper.vue?vue&type=style&index=0&id=df8949aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8949aa",
  null
  
)

export default component.exports